import {
  calculateVariation,
  calculateVariationDirection,
  type BoxDashboardKpiEntity,
  type VariationDirection,
} from "@/modules/boxDashboard/modules/KPI/entities/boxDashboardKpiEntity"

export type OfferCountModel = {
  count: number
  comparisonCount: number | null
  variationDirection: VariationDirection | null
}

export type ActiveOffersKpiModel = {
  membership: OfferCountModel
  classPass: OfferCountModel
  withoutOffers: OfferCountModel
}

export function createEmptyActiveOffersKpiModel(): ActiveOffersKpiModel {
  return {
    membership: {
      count: 0,
      comparisonCount: null,
      variationDirection: null,
    },
    classPass: {
      count: 0,
      comparisonCount: null,
      variationDirection: null,
    },
    withoutOffers: {
      count: 0,
      comparisonCount: null,
      variationDirection: null,
    },
  }
}

export function createActiveOffersKpiModel(entity: BoxDashboardKpiEntity): ActiveOffersKpiModel {
  const membershipFocus = entity.offers.membership.baseline
  const membershipComparison = entity.offers.membership.comparison

  const classPassFocus = entity.offers.classPass.baseline
  const classPassComparison = entity.offers.classPass.comparison

  const withoutOffersFocus = entity.offers.none.baseline
  const withoutOffersComparison = entity.offers.none.comparison

  return {
    membership: {
      count: membershipFocus,
      comparisonCount: calculateVariation(membershipFocus, membershipComparison),
      variationDirection: calculateVariationDirection(membershipFocus, membershipComparison),
    },
    classPass: {
      count: classPassFocus,
      comparisonCount: calculateVariation(classPassFocus, classPassComparison),
      variationDirection: calculateVariationDirection(classPassFocus, classPassComparison),
    },
    withoutOffers: {
      count: withoutOffersFocus,
      comparisonCount: calculateVariation(withoutOffersFocus, withoutOffersComparison),
      variationDirection: calculateVariationDirection(withoutOffersFocus, withoutOffersComparison),
    },
  }
}
